export const formatCurrency = (currency: string, value?: number | null) => {
  if (value == null || value == undefined) return

  const formatter = Intl.NumberFormat(undefined, { style: 'currency', currency })
  return formatter.format(value / 100)
}
